module.exports = __webpack_public_path__ + "72fc0629b5745867f636e308a9cca387.svg";